import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType, IAPIresponse, IString } from '../../model';
import { IStudioInfo } from '../../model/api-modules/studio';
import { ADMIN_PREFIX, STUDIO_PREFIX } from '../config';

// 基础信息查看
export const getStudioInfo = (studioId: string) =>
  withAPIAccount(AccountType.auto, async (api): Promise<IAPIresponse> => {
    try {
      const url = `${STUDIO_PREFIX}/${studioId}`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IAPIresponse>(response, 'all');
      return res;
    } catch (error) {
      // if (error instanceof APIError) {
      //   messageError(error.message);
      // }
      return {};
    }
  });

// 基础信息修改
export const updateStudioInfo = (studioId: string, data: IString<string>) =>
  withAPIAccount(AccountType.auto, async (api): Promise<boolean> => {
    try {
      const url = `${STUDIO_PREFIX}/${studioId}`;
      const response = await api.commonRequest('PUT', url, data);

      const res = await parsedResponse(response, 'data');
      if (res) {
        return true;
      }
      return false;
    } catch (error) {
      console.log('failed: updateStudioInfo', error);
      return false;
    }
  });

// 获取所有工作室
export const getAllStudio = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/studio`;
      const response = await api.commonRequest('GET', url);
      return await parsedResponse<IStudioInfo[]>(response, 'data');
    } catch (error) {
      return false;
    }
  });

// 创建工作室
export const createStudio = (Name: string) =>
  withAPIAccount(
    AccountType.auto,
    async (api): Promise<{ maxLimit?: number }> => {
      const url = `${STUDIO_PREFIX}`;
      const response = await api.commonRequest('POST', url, {
        Name,
      });
      const res = await parsedResponse<{ maxLimit: number }>(response, 'data');
      return res;
    }
  );
// 删除工作室
export const deleteStudio = (studioID: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${STUDIO_PREFIX}/${studioID}`;
      const response = await api.commonRequest('DELETE', url, { studioID });
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: deleteStudio', error);
      throw error;
    }
  });
